import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Row, Col } from 'antd';
import { CustomDivider } from '../../../custom_shared/components';
import { InputBaseModel } from '../../models';
import { InputChangeTracker } from '../../change_trackers';
import { InputRenderer } from '..';
import { StyleUtils } from '../../misc';
import { InputChangeType } from '../../types';
import './ContractComparisonRow.less';

const changeTypeLabels: Record<InputChangeType, string> = {
    added: 'Added',
    removed: 'Removed',
    modified: 'Modified',
    unsaved: 'Unsaved Changes'
} as const;

interface Props {
    inputChangeTracker: InputChangeTracker;
    newInput?: InputBaseModel;
    previousInput?: InputBaseModel;
    component?: React.FunctionComponent;
    isLast: boolean;
}

const ContractComparisonRow: React.FC<Props> = ({ inputChangeTracker, newInput, previousInput, component, isLast }) => {
    const renderInput = (input?: InputBaseModel, isUnsavedInput: boolean = false) => {
        if (!input) {
            return (
                <div className="no-input-container">
                    <span className="no-input-label">—</span>
                </div>
            );
        }

        return (
            <div className={`comparison-input-container${isUnsavedInput ? ' unsaved' : ''}`}>
                <InputRenderer input={input} component={component} />
            </div>
        );
    };

    return (
        <>
            <Row className="contract-comparison-row" gutter={10} style={{ padding: '0 10px' }}>
                <Col style={StyleUtils.getNodeColumnStyleByPercentage(40)}>{renderInput(previousInput)}</Col>
                <Col style={StyleUtils.getNodeColumnStyleByPercentage(40)}>
                    {renderInput(newInput, inputChangeTracker.changeType === 'unsaved')}
                </Col>
                <Col style={StyleUtils.getNodeColumnStyleByPercentage(20)}>
                    {inputChangeTracker.changeType && (
                        <div className="change-type-container">
                            <span className={`change-type-label ${inputChangeTracker.changeType}`}>
                                {changeTypeLabels[inputChangeTracker.changeType]}
                            </span>
                        </div>
                    )}
                </Col>
            </Row>

            {!isLast && <CustomDivider type="horizontal" />}
        </>
    );
};

export default observer(ContractComparisonRow);
